/** Browser — the in-app browser agents drive, and what it may do unasked. */
import { BrowserSection } from "./BrowserSection";
import { SettingsPageContainer } from "./settingsLayout";

export function BrowserSettingsPage() {
  return (
    <SettingsPageContainer>
      <BrowserSection />
    </SettingsPageContainer>
  );
}
